import { directoryLogoPath, defaultLogoPath, mapBrands } from './BrandMapping'

const classNameJobTile: string = 'attrax-vacancy-tile'
const classNameContainerLogo: string = `${classNameJobTile}__container-logo`
const classNameLogo: string = `${classNameJobTile}__logo`

export const initialise = () => {
    const jobTiles: NodeListOf<HTMLDivElement> = document.querySelectorAll(`.${classNameJobTile}`)
    if (!jobTiles) return

    logoContainer(jobTiles)
    wrappDetails(jobTiles)
    updateLogo()
}

const logoContainer = (jobTiles: NodeListOf<HTMLDivElement>) => {
    jobTiles.forEach((jobTile: HTMLDivElement) => {
        let container: HTMLDivElement = document.createElement('div')
        container.classList.add(classNameContainerLogo)
        jobTile.prepend(container)

        let logo: HTMLImageElement = document.createElement('img')
        logo.alt = ''
        logo.loading = 'lazy'
        logo.height = 40
        logo.width = 300
        logo.src = defaultLogoPath
        logo.className = classNameLogo
        container.appendChild(logo)
    })
}

const wrappDetails = (jobTiles: NodeListOf<HTMLDivElement>) => {
    const optionsClasses: string[] = ['attrax-vacancy-tile__option-department', 'attrax-vacancy-tile__option-type-of-employment', 'attrax-vacancy-tile__option-institution', 'attrax-vacancy-tile__location-freetext']
    jobTiles.forEach((jobTile: HTMLDivElement) => {
        const detailsContainer: HTMLDivElement = document.createElement('div')
        detailsContainer.classList.add(`${classNameJobTile}__details`)
        jobTile.appendChild(detailsContainer)

        optionsClasses.forEach((optionClass: string) => {
            const option: HTMLElement | null = jobTile.querySelector(`.${optionClass}`)
            if (!option) return
            detailsContainer.appendChild(option)
        })
    })
}

const updateLogo = () => {
    mapBrands.forEach((fileType: string, fileName: string) => {
        const classNameBrand: string = `.${classNameJobTile}--${fileName}`

        let brandFileName: string = `${fileName}.${fileType}`
        const filePath: string = `${directoryLogoPath}/${brandFileName}`
        const brandOptions: NodeListOf<HTMLElement> = document.querySelectorAll(classNameBrand)

        brandOptions.forEach((brandOption: HTMLElement) => {
            const jobTile = brandOption.closest<HTMLElement>(`.${classNameJobTile}`)
            if (!jobTile) return
            const container = jobTile.querySelector<HTMLElement>(`.${classNameContainerLogo}`)
            if (!container) return
            const logo = container.querySelector<HTMLImageElement>('img')
            if (!logo) return
            logo.src = filePath
        })
    })
}